import React, { useState } from 'react'
import Icons from '../../Constants/Icons'
import PhoneInput from 'react-phone-input-2'

const Footer = ({ ref }) => {
  const [value, setValue] = useState()

  return (
    <div
      ref={ref}
      className='footer-min'
      style={{ height: 'auto', zIndex: '1', position: 'relative' }}
    >
      <footer
        id='contactus'
        className='main-footer bg-cover pt-60 pb-20 footer-stuck is-inview'
        style={{
          backgroundImage: `url(${Icons.bg122})`,
          position: 'relative',
          bottom: '0px',
          width: '100%',
          zIndex: '99'
          // height: '600px',
          // overflow: 'auto'
        }}
      >
        <section style={{ backgroundColor: 'transparent' }}>
          <div className='container mx-auto px-4'>
            <div className=' flex-wrap'>
              {/* Contact Form Section */}
              <div className='lqd-column '>
                <div className='section-title left'>
                  <h1 style={{ textAlign: 'center' }}>Contact us:</h1>
                </div>
                <div className='contact-forms'>
                  <form>
                    <div className='row'>
                      <div className='col-md-6'>
                        <label className='block text-gray-700'>Name</label>
                        <input
                          type='text'
                          className='form-control w-full p-2 border'
                          placeholder='Name'
                        />
                      </div>

                      <div className='col-md-6'>
                        <label className='block text-gray-700'>Email</label>
                        <input
                          type='email'
                          className='form-control w-full p-2 border'
                          placeholder='Email'
                        />
                      </div>
                      <div
                        className='col-md-12'
                        style={{ marginBottom: '20px' }}
                      >
                        <label className='block text-gray-700'>
                          Phone Number
                        </label>
                        <PhoneInput
                          country={'ca'}
                          className='PhoneInput'
                          placeholder='Phone Number'
                          value={value}
                          onChange={setValue}
                        />
                      </div>
                      <div className='col-md-12'>
                        <label className='block text-gray-700'>Message</label>
                        <textarea
                          className='form-control w-full p-2 border'
                          placeholder='Message'
                        ></textarea>
                      </div>
                    </div>
                    <div className='text-right mt-4'>
                      <input
                        type='submit'
                        className='btn-gold bg-yellow-500 text-white px-6 py-2 rounded'
                        value='Submit'
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <div className='lqd-column  mb-30 mt-50'>
                  <div className='footer-logo mb-40' style={{ margin: 'auto' }}>
                    <img src={Icons.logo} alt='Company Logo' />
                  </div>
                  <div
                    style={{
                      marginTop: '10px',
                      color: 'white',
                      textAlign: 'center'
                    }}
                  >
                    <img src={Icons.Location} style={{ height: '17px' }} /> -
                    3575 Rue Ashby, Montreal, QC, H4R2K3
                  </div>
                  <div
                    style={{ display: 'block', flexWrap: 'wrap', gap: '20px' }}
                  >
                    <div
                      style={{
                        marginTop: '10px',
                        color: 'white',
                        textAlign: 'center'
                      }}
                    >
                      ✉️ vendu@maisonsdirect.ca
                    </div>
                    <div
                      style={{
                        marginTop: '10px',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='white'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path d='M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15 15C15.25 14.75 15.57 14.63 15.91 14.63C16.14 14.63 16.37 14.7 16.56 14.84L20.18 17.29C20.56 17.54 20.78 17.96 20.78 18.41V21C20.78 21.55 20.33 22 19.78 22C10.35 22 3 14.65 3 5.22C3 4.67 3.45 4.22 4 4.22H6.58C7.04 4.22 7.46 4.44 7.71 4.82L10.16 8.44C10.3 8.63 10.37 8.86 10.37 9.09C10.37 9.43 10.25 9.75 10 10L6.62 10.79Z' />
                      </svg>
                      +1 514-898-8000
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='copyright'>
              <p className='text-gray-600'>Copyright {new Date().getFullYear()} MaisonsDirect</p>
            </div>
          </div>
        </section>
      </footer>
    </div>
  )
}

export default Footer
